<template>
  <div class="card-modern">
  
    <!-- Header -->
    <div class="d-flex align-items-start justify-content-between mb-3 flex-wrap gap-3">
      <div>
        <h2 class="card-title-modern">
          Monitoring Penawaran yang Memiliki Perjanjian
        </h2>
        <p class="card-desc-modern mb-0">
          Pantau customer yang memiliki dokumen perjanjian kerja sama.
        </p>
      </div>
    </div>
  
    <!-- Search & Filter -->
    <div class="d-flex align-items-center justify-content-end gap-2 mb-3 flex-wrap">
      <div class="position-relative" style="width:170px">
        <i class="bi bi-search position-absolute" style="left:14px;top:50%;transform:translateY(-50%);color:#94a3b8"></i>
        <input v-model="search" type="text" class="form-control" style="padding-left:38px" placeholder="Cari"
          @input="onSearch">
      </div>
  
      <select v-model="pksStatus" class="form-select" style="width:170px" @change="applyFilters">
        <option value="">Semua Status</option>
        <option value="DONE">Sudah Ada SPK</option>
        <option value="PENDING">Belum Ada SPK</option>
      </select>
    </div>
  
    <!-- Table -->
    <div class="modern-table-wrapper">
      <table class="table-modern">
        <thead>
          <tr>
            <!-- <th>No</th> -->
            <th>Nama Perusahaan</th>
            <th>Nomor Dokumen</th>
            <th class="text-center">Status</th>
            <th class="text-center">Aksi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="isLoading">
            <td colspan="5" class="text-center py-4 text-muted">Memuat data...</td>
          </tr>
  
          <tr v-else-if="!items.length">
            <td colspan="5" class="text-center py-5 text-muted">
              <i class="bi bi-folder2-open d-block mb-2" style="font-size:2rem;color:#94a3b8"></i>
              Tidak ada data ditemukan.
            </td>
          </tr>
  
          <tr v-else v-for="(item) in items" :key="item.transport_offer_id">
            <!-- <td>{{ (page - 1) * perPage + index + 1 }}</td> -->
            <td class="fw-semibold">{{ item.mst_corporate_name || '-' }}</td>
            <td>{{ item.document_number || '-' }}</td>
            <td class="text-center">
              <span v-if="item.pks_status === 'DONE'" class="badge-modern badge-success">
                <i class="bi bi-check-circle-fill me-1"></i> Sudah
              </span>
              <span v-else class="badge-modern badge-danger">
                <i class="bi bi-exclamation-triangle-fill me-1"></i> Belum
              </span>
            </td>
            <td class="text-center">
              <button v-if="item.pks_status === 'DONE'" class="btn-icon-hover icon-primary" @click="viewDocument(item)"
                title="Lihat Dokumen SPK">
                <i class="bi bi-eye me-1"></i>
              </button>
              <button v-else class="button-modern btn-sm" @click="createPks(item)" title="Buat Dokumen SPK">
                <i class="bi bi-plus-lg me-1"></i>Buat SPK
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  
    <!-- Pagination -->
    <div v-if="items.length" class="d-flex align-items-center justify-content-between mt-3">
      <small class="text-muted">
        Menampilkan {{ (page - 1) * perPage + 1 }} - {{ Math.min(page * perPage, total) }} dari {{ total }} data
      </small>
      <div class="d-flex align-items-center gap-2">
        <small class="text-muted">Rows per page</small>
        <select v-model.number="perPage" class="form-select form-select-sm" style="width: 70px;" @change="changePerPage">
          <option v-for="opt in perPageOptions" :key="opt" :value="opt">{{ opt }}</option>
        </select>
        <nav>
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" :class="{ disabled: page === 1 }">
              <button class="page-link" @click="fetchData(page - 1)">‹</button>
            </li>
            <li v-for="(p, idx) in visiblePages" :key="idx" class="page-item"
              :class="{ active: p === page, disabled: p === '...' }">
              <button class="page-link" @click="p !== '...' && fetchData(p)">{{ p }}</button>
            </li>
            <li class="page-item" :class="{ disabled: page === totalPages }">
              <button class="page-link" @click="fetchData(page + 1)">›</button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  
  </div>
</template>

<script>
import PksViewJs from "./PksView";
export default PksViewJs;
</script> 